module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "meeting"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteMeeting(_vm.meeting.id)
      }
    }
  }), _vm._v(" "), _c('b-switch', {
    staticClass: "hide-from-site",
    on: {
      "change": _vm.handleUpdateMeeting
    },
    model: {
      value: (_vm.meeting.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.meeting, "isHidden", $$v)
      },
      expression: "meeting.isHidden"
    }
  }, [_vm._v("\n      Скрыть с сайта\n    ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Дата встречи"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetime",
      "placeholder": "00:00"
    },
    on: {
      "change": _vm.datePickerChanged
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Название"
    }
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdateMeeting
    },
    model: {
      value: (_vm.meeting.title),
      callback: function($$v) {
        _vm.$set(_vm.meeting, "title", $$v)
      },
      expression: "meeting.title"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Описание"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": "q" + _vm.meeting.id
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Ссылка"
    }
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdateMeeting
    },
    model: {
      value: (_vm.meeting.link),
      callback: function($$v) {
        _vm.$set(_vm.meeting, "link", $$v)
      },
      expression: "meeting.link"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('b-switch', {
    staticClass: "hide-from-site",
    on: {
      "change": _vm.handleUpdateMeeting
    },
    model: {
      value: (_vm.meeting.publishLater),
      callback: function($$v) {
        _vm.$set(_vm.meeting, "publishLater", $$v)
      },
      expression: "meeting.publishLater"
    }
  }, [_vm._v("\n          Опубликовать позже\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('el-date-picker', {
    staticClass: "publish-date is-pulled-right",
    attrs: {
      "editable": false,
      "type": "date",
      "placeholder": "Дата публикации на сайте"
    },
    on: {
      "change": _vm.publishDateChanged
    },
    model: {
      value: (_vm.publishDate),
      callback: function($$v) {
        _vm.publishDate = $$v
      },
      expression: "publishDate"
    }
  })], 1)]), _vm._v(" "), (_vm.meeting.meetingParticipants && _vm.meeting.meetingParticipants.length) ? _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.toggleParticipants
    }
  }, [_vm._v("\n      Количество заявок: " + _vm._s(_vm.meeting.meetingParticipants.length) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.meeting.meetingParticipants) ? _c('el-dialog', {
    staticClass: "webinar-dialog",
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "club-members"
  }, [_c('span', {
    staticClass: "club-members-count"
  }, [_vm._v("\n        Количество заявок: " + _vm._s(_vm.meeting.meetingParticipants.length) + "\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "club-members-table"
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("Имя")]), _vm._v(" "), _c('td', {
    staticClass: "lastname"
  }, [_vm._v("Фамилия")]), _vm._v(" "), _c('td', {
    staticClass: "email"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', {
    staticClass: "phone"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('td', {
    staticClass: "date"
  }, [_vm._v("Дата заявки")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.meeting.meetingParticipants), function(member) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(member.name) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "lastname"
    }, [_vm._v(" " + _vm._s(member.lastname) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "email"
    }, [_vm._v(" " + _vm._s(member.email) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "phone"
    }, [_vm._v(" " + _vm._s(member.phone))]), _vm._v(" "), _c('td', {
      staticClass: "date"
    }, [_vm._v(" " + _vm._s(_vm._f("filterDate")(member.date)))]), _vm._v(" "), _c('td', {
      staticClass: "delete-member"
    }, [_c('img', {
      staticClass: "delete-icon",
      attrs: {
        "src": "/static/img/icons/delete.svg"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMeetingParticipant(member.id)
        }
      }
    })])])
  }), 0)])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b68ced32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/Meeting.vue
// module id = 995
// module chunks = 0